import { Editor } from '@tiptap/react';
import React from 'react';
import Box from '@mui/material/Box';
import {
  BlockQuoteIcon,
  BoldIcon,
  BulletListIcon,
  H1Icon,
  H2Icon,
  H3Icon,
  HorizontalRuleIcon,
  ItalicIcon,
  OrderedListIcon,
  RedoIcon,
  UndoIcon,
} from '../../icons/icons';
import { IconButton } from './IconButton';

interface EditorToolbarProps {
  editor: Editor | null;
}

const EditorToolbar: React.FC<EditorToolbarProps> = ({ editor }) => {
  if (!editor) {
    return null;
  }

  const BUTTON_DATA = [
    {
      action: 'bold',
      onClick: () => editor.chain().focus().toggleBold().run(),
      icon: <BoldIcon />,
    },
    {
      action: 'italic',
      onClick: () => editor.chain().focus().toggleItalic().run(),
      icon: <ItalicIcon />,
    },
    {
      action: 'h1',
      onClick: () => editor.chain().focus().toggleHeading({ level: 1 }).run(),
      icon: <H1Icon />,
    },
    {
      action: 'h2',
      onClick: () => editor.chain().focus().toggleHeading({ level: 2 }).run(),
      icon: <H2Icon />,
    },
    {
      action: 'h3',
      onClick: () => editor.chain().focus().toggleHeading({ level: 3 }).run(),
      icon: <H3Icon />,
    },
    {
      action: 'bullet-list',
      onClick: () => editor.chain().focus().toggleBulletList().run(),
      icon: <BulletListIcon />,
    },
    {
      action: 'ordered-list',
      onClick: () => editor.chain().focus().toggleOrderedList().run(),
      icon: <OrderedListIcon />,
    },
    {
      action: 'blockquote',
      onClick: () => editor.chain().focus().toggleBlockquote().run(),
      icon: <BlockQuoteIcon />,
    },
    {
      action: 'horizontal-rule',
      onClick: () => editor.chain().focus().setHorizontalRule().run(),
      icon: <HorizontalRuleIcon />,
    },
    {
      action: 'undo',
      onClick: () => editor.chain().focus().undo().run(),
      icon: <UndoIcon />,
    },
    {
      action: 'redo',
      onClick: () => editor.chain().focus().redo().run(),
      icon: <RedoIcon />,
    },
  ];

  return (
    <Box
      sx={{
        display: 'flex',
        maxWidth: '100%',
        flexDirection: 'row',
        gap: 0.75,
        overflowX: 'auto',
        borderRadius: '12px',
        bgcolor: 'action.hover',
        p: 0.75,
        mb: 2,
        border: '1px solid',
        borderColor: 'divider',
      }}
    >
      {BUTTON_DATA.map((button) => (
        <IconButton
          key={button.action}
          onClick={button.onClick}
          icon={button.icon}
        />
      ))}
    </Box>
  );
};

export default EditorToolbar;
